import React, { ReactNode, useContext, useEffect, useState } from "react";
import { TabGestaoCobrancas } from "../TabGestaoCobrancas";
import { TabProcessosJudiciais } from "../TabProcessosJudiciais";
import { TabAgendamentos } from "../TabAgendamentos";
import { Panel } from "shared/components/panel/Panel";
import BodyPanel from "shared/components/panel/BodyPanel";
import HeaderPanel from "shared/components/panel/HeaderPanel";
import CustomButton from "shared/components/button/CustomButton";
import { EnumTipoTabGestaoCobranca } from "constants/EnumTipoTabGestaoCobranca";
import { UserContext } from "context/UserContext";
import { useAgendamentoContatoContext } from "context/gestaoCobranca/AgendamentoContatoContext";
import { FaCalendarAlt } from "react-icons/fa";
import { TabType } from "types/tab/TabType";
import Tabs from "shared/components/tabs/Tabs";
import { useProcessosJudiciaisContext } from "context/gestaoCobranca/ProcessosJudiciaisContext";

export const GestaoCobranca: React.FC = () => {
  const [activeTab, setActiveTab] = useState<EnumTipoTabGestaoCobranca>(EnumTipoTabGestaoCobranca.GESTAO_COBRANCA);
  const { openCloseModalAgendamentoContato, possuiAcessoTelaAgendamento, possuiPermissaoIncluirAgendamento } =
    useAgendamentoContatoContext();
  const { possuiAcessoTelaProcessosJudiciais, possuiPermissaoIncluirProcessosJudiciais } =
    useProcessosJudiciaisContext();
  const { openCloseModalProcessosJudiciais } = useProcessosJudiciaisContext();
  const { usuarioLogado } = useContext(UserContext);

  const criarAbas = (): TabType[] => {
    const abas: TabType[] = [
      {
        id: 1,
        title: "Gestão de cobranças",
        content: <TabGestaoCobrancas />,
        tipoTab: EnumTipoTabGestaoCobranca.GESTAO_COBRANCA,
      },
      {
        id: 2,
        title: "Agendamentos",
        content: <TabAgendamentos />,
        tipoTab: EnumTipoTabGestaoCobranca.AGENDAMENTO,
        hide: !possuiAcessoTelaAgendamento,
      },
      {
        id: 3,
        title: "Processos judiciais",
        content: <TabProcessosJudiciais />,
        tipoTab: EnumTipoTabGestaoCobranca.PROCESSOS_JUDICIAIS,
        hide: !possuiAcessoTelaProcessosJudiciais,
      },
    ];

    return abas;
  };
  const [abas, setAbas] = useState<TabType[]>([]);

  useEffect(() => {
    setAbas(criarAbas());
  }, []);

  const renderBotoesHeaderPanel = (): ReactNode[] => {
    let botoes = [];
    if (activeTab === EnumTipoTabGestaoCobranca.AGENDAMENTO && possuiPermissaoIncluirAgendamento) {
      botoes.push(
        <CustomButton
          key={"btnAgendamento"}
          variant="primary"
          className="e-5"
          leftIcon={FaCalendarAlt}
          id="btnAgendamento"
          label="Agendar contato"
          onClick={() => openCloseModalAgendamentoContato()}
        />
      );
    } else if (
      activeTab === EnumTipoTabGestaoCobranca.PROCESSOS_JUDICIAIS &&
      possuiPermissaoIncluirProcessosJudiciais
    ) {
      botoes.push(
        <CustomButton
          key={"btnProcessosJudiciais"}
          variant="primary"
          className="e-5"
          id="btnAgendamento"
          label="Cadastrar"
          onClick={() => {
            openCloseModalProcessosJudiciais();
          }}
        />
      );
    } else {
      botoes = [];
    }

    return botoes;
  };

  return (
    <Panel
      headerPanel={
        <HeaderPanel
          title="Gestão de Cobranças"
          botoes={renderBotoesHeaderPanel()}
          ocultarCondominio={!usuarioLogado.condominioContextoId}
          abaAtual={activeTab}
        />
      }
    >
      <BodyPanel noPadding>
        <Tabs tabs={abas} activeTab={activeTab} changeActiveTab={setActiveTab} />
      </BodyPanel>
    </Panel>
  );
};
